import { Text } from '@betterment/samba-react';

import { ModalSection } from '../../modal-section/ModalSection';
import { ModalSectionRow } from '../../modal-section/ModalSectionRow';

import type { AccountSettingsUrlBuilders, RenderDeletePurposeAction } from '../contentTypes';
import type { CashAccount, ManagedAccount } from '../data';

type PurposeSectionAccount = CashAccount | ManagedAccount;

type PurposeSectionProps = {
  account: PurposeSectionAccount;
  currentPath: string;
  urlBuilders: Pick<AccountSettingsUrlBuilders, 'editPurpose'>;
  renderDeletePurpose?: RenderDeletePurposeAction;
  purposelessCopy?: string;
};

export const PurposeSection: React.FC<PurposeSectionProps> = ({
  account,
  urlBuilders,
  renderDeletePurpose,
  purposelessCopy,
}) => {
  const {
    id: accountId,
    name: accountName,
    envelope: { purpose },
  } = account;

  if (!purpose) {
    return (
      <ModalSection header="Goal" cta={urlBuilders.editPurpose ? urlBuilders.editPurpose : undefined}>
        <ModalSectionRow>
          <ModalSectionRow.LeadingContent>
            <Text>{purposelessCopy || 'Assign this account to a goal for additional advice on how to save.'}</Text>
          </ModalSectionRow.LeadingContent>
        </ModalSectionRow>
      </ModalSection>
    );
  }

  const isRetirementPurpose =
    purpose.__typename === 'PurposeRetirementGrowth' || purpose.__typename === 'PurposeRetirementIncome';
  const canDeletePurpose =
    !isRetirementPurpose && (account.__typename === 'ManagedAccount' || account.__typename === 'CashAccount');

  const deleteAction =
    renderDeletePurpose &&
    canDeletePurpose &&
    renderDeletePurpose({
      accountId,
      accountName,
      purposeId: purpose.id,
      purposeName: purpose.name,
      legacyGoalId: account.legacyGoalId,
      legacyId: account.__typename === 'ManagedAccount' ? account.legacyId : undefined,
      accountType: account.__typename,
    });

  return (
    <ModalSection header="Goal">
      <ModalSectionRow>
        <ModalSectionRow.LeadingContent>
          <Text>Assigned to</Text>
        </ModalSectionRow.LeadingContent>
        <ModalSectionRow.TrailingContent>
          <Text>{purpose.name}</Text>
          {deleteAction}
        </ModalSectionRow.TrailingContent>
      </ModalSectionRow>
    </ModalSection>
  );
};
